export const TEXTAREA_CHARACTER_LIMIT = 60

export const QUANTITY_INPUT = 'QUANTITY_INPUT'

export const QUANTITY_CONFIRMATION_THRESHOLD = 99
